/**
 * @des bi api
 * 
 */

const BASE_URL = '/bi/v1/statistics';

function generateUrl(url, data, method = 'get') {
    return {
        url: `${BASE_URL}/${url}`,
        method,
        data,
        params: data,
    }
}

export default API => ({


    /**
     * 获取汇总数据
     * @returns {*}
     */
    getSummarizedData() {
        return API(generateUrl('getSummarizedData'))
    },

    /**
     *   获取用户统计数据
     */
    getUserStatisticsData(data) {
        return API(generateUrl('getUserStatisticsData', data))
    },

    /**
     * 获取课程和用户任务
     * @param data
     * @returns {*}
     */
    getCourseAndUserSchedule(data) {
        return API(generateUrl('getCourseAndUserSchedule', data))
    },

    /**
     * 获取训练营统计
     * @returns {*}
     */
    getTrainSchedule() {
        return API(generateUrl('getTrainSchedule'))
    }
})